// @ts-check

import { Fragment } from 'react';
// @ts-expect-error Don't know how to fix this using JSDoc
import Url from '@core/scripts/helper/url';
import './jsdoc-types.js';
import slug from "slug";

/**
 * @param {NavigationItemEntry} item
 */
export const navigationItemIsCurrentPage = (item) => {
    const url = new URL(Url.toAbsolute(item.fields.slug || item.fields.page.fields.slug));
    return url.pathname === window.location.pathname;
};

/**
 * @param {string} slug
 */
export const slugIsCurrentPage = (slug) => {
    const url = new URL(Url.toAbsolute(slug));
    return url.pathname === window.location.pathname;
};

/**
 * @param {NavigationItemEntry} item
 */
export const navigationItemIsParentPage = (item) => {
    const url = new URL(Url.toAbsolute(item.fields.slug || item.fields.page.fields.slug));
    return window.location.pathname.startsWith(url.pathname);
};

/**
 * @param {NavigationItemEntry} item
 */
export const getSlugFromNavigationItem = (item) => item.fields.slug || item.fields.page.fields.slug;

export const insertReactComponentIntoString = (string, placeholder, component) => {
    const parts = (string || "").split(placeholder);
    return (
        <>
            {parts.map((part, index) => (
                <Fragment key={index}>
                    {part}
                    {index < parts.length - 1 && component}
                </Fragment>
            ))}
        </>
    );
};

export const nodeForHeading = (node) => node.content.find(c => c.nodeType === "text" && c.value !== "\n");

/**
 *
 * @param assetUrl {string|undefined}
 * @returns {string}
 */
export const rewriteAssetUrl = (assetUrl) => {
    if (!assetUrl) {
        return '';
    }
    const parsedUrl = new URL(assetUrl, 'https://images.eu.ctfassets.net');

    if(parsedUrl.hostname !== 'images.eu.ctfassets.net') {
        return assetUrl;
    }

    parsedUrl.hostname = 'contentful-images.bonprix.com';
    return parsedUrl.toString();
}
/**
 *
 * @param title {string}
 * @returns {string}
 */
export const safeSlug = (title) => {
    const baseSlug = slug(title);
    // Prefix with a letter if the slug starts with a digit
    return /^\d/.test(baseSlug) ? `id-${baseSlug}` : baseSlug;
}